import TemplateAp1 from '../../../../assets/images/png/editor/template-ap1.png'
import TemplateAp4 from '../../../../assets/images/png/editor/template-ap4.png'
import TemplateAp9 from '../../../../assets/images/png/editor/template-ap9.png'
import TemplateAp16 from '../../../../assets/images/png/editor/template-ap16.png'
import DownloadIcon from '../../../../assets/images/png/editor/download.png'
import FBIcon from '../../../../assets/images/png/editor/facebook.png'
import LinkedInIcon from '../../../../assets/images/png/editor/linkedin.png'
import YoutubeIcon from '../../../../assets/images/png/editor/youtube.png'
import InstagramIcon from '../../../../assets/images/png/editor/instagram.png'
import SnapChatIcon from '../../../../assets/images/png/editor/snapchat.png'
import TwitterIcon from '../../../../assets/images/png/editor/twitter.png'
import TikTokIcon from '../../../../assets/images/png/editor/tiktok.png'
import TwitchIcon from '../../../../assets/images/png/editor/twitch.png'

export const TemplateAp1Png = TemplateAp1
export const TemplateAp4Png = TemplateAp4
export const TemplateAp9Png = TemplateAp9
export const TemplateAp16Png = TemplateAp16
export const DownloadIconPng = DownloadIcon
export const FBIconPng = FBIcon
export const LinkedInIconPng = LinkedInIcon
export const YoutubeIconPng = YoutubeIcon
export const InstagramIconPng = InstagramIcon
export const SnapChatIconPng = SnapChatIcon
export const TwitterIconPng = TwitterIcon
export const TikTokIconPng = TikTokIcon
export const TwitchIconPng = TwitchIcon
